import React from 'react';

import clsx from 'clsx';

import { CollateralStatus } from '__generated__/globalTypes';
import { GetDealDiligence_deal_diligence } from 'query/diligence';
interface DiligenceStatusProps {
  diligenceData: GetDealDiligence_deal_diligence[];
}

const orderedStatuses: CollateralStatus[] = [
  CollateralStatus.REQUIRED,
  CollateralStatus.RECEIVED,
  CollateralStatus.IN_PROGRESS,
  CollateralStatus.ADDITIONAL_QA_REQUIRED,
  CollateralStatus.COMPLETED,
  CollateralStatus.REJECTED,
];

const statusLabels: { [key in CollateralStatus]: string } = {
  [CollateralStatus.ADDITIONAL_QA_REQUIRED]: 'Additional QA Required',
  [CollateralStatus.COMPLETED]: 'Completed',
  [CollateralStatus.IN_PROGRESS]: 'In Progress',
  [CollateralStatus.RECEIVED]: 'Received',
  [CollateralStatus.REJECTED]: 'Rejected',
  [CollateralStatus.REQUIRED]: 'Required',
};

export const DiligenceStatus: React.FC<DiligenceStatusProps> = ({ diligenceData }) => {
  const statusCounts: { [key: string]: number } = {};
  let totalCollateral = 0;

  diligenceData.forEach((diligence) => {
    diligence.collateral.forEach((collateral) => {
      if (collateral.collateralStatus !== null) {
        statusCounts[collateral.collateralStatus] =
          (statusCounts[collateral.collateralStatus] || 0) + 1;
      }
      totalCollateral++;
    });
  });

  const fields = orderedStatuses.map((status) => ({
    label: statusLabels[status] || status,
    valueAsPercentage:
      totalCollateral !== 0
        ? Math.round(((statusCounts[status] || 0) / totalCollateral) * 100)
        : null,
  }));

  return (
    <>
      {fields.map((field) => (
        <div
          key={field.label}
          className="font-heebo text-xs font-normal leading-5 text-foreground-default"
        >
          {field.label}{' '}
          <span
            className={clsx('font-pt-sans-narrow text-sm font-bold leading-4', {
              'text-foreground-subtle':
                field.valueAsPercentage === null || field.valueAsPercentage === 0,
              'text-success-default': field.valueAsPercentage === 100,
              'text-info-muted':
                field.valueAsPercentage !== null &&
                field.valueAsPercentage !== 0 &&
                field.valueAsPercentage !== 100,
            })}
          >
            {field.valueAsPercentage !== null ? `${field.valueAsPercentage}%` : '-'}
          </span>
        </div>
      ))}
    </>
  );
};
